var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title is-3"},[_vm._v("Users")]),_c('b-table',{staticClass:"mb-2",attrs:{"data":_vm.users,"columns":_vm.columns}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('small',[_vm._v(" 👑"),_c('i',[_vm._v(" denotes an admin ")])])
}]

export { render, staticRenderFns }